import React from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import {
    Box,
    ListItem,
    ListItemButton,
    Typography,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
import { useTranslation } from 'react-i18next';

import ItemPreviewPage from './ItemPreviewPage';

const SortableItem = ({
    canUpdate,
    handleClickDelete,
    handleClickDuplicate,
    handleClickSelect,
    selectedPageId,
    index,
    item,
    refDictionary,
}) => {
    const { t } = useTranslation();
    return (
        <Draggable
            draggableId={item.id || 'tempPage'}
            index={index}
            isDragDisabled={!canUpdate}
        >
            {(provided, snapshot) => (
                <ListItem
                    disablePadding
                    tabIndex={0}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                >
                    <ListItemButton
                        ref={(ref) => {
                            refDictionary[item.id] = ref;
                        }}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                        }}
                    >
                        <Box
                            alignItems="center"
                            display="flex"
                            gap={1}
                            sx={{ ml: 'auto' }}
                        >
                            {item.type !== 'group' && !snapshot.isDragging && (
                                <FileCopyIcon
                                    onClick={() => handleClickDuplicate(item)}
                                    fontSize="small"
                                    sx={{ color: '#ffffff' }}
                                />
                            )}
                            {!snapshot.isDragging && (
                                <DeleteIcon
                                    onClick={() =>
                                        handleClickDelete(
                                            item.id,
                                            item.type === 'page',
                                        )
                                    }
                                    fontSize="small"
                                    sx={{ color: '#ffffff' }}
                                />
                            )}
                        </Box>
                        <Box mt={1} sx={{ position: 'relative' }}>
                            <Box sx={{ m: 1, position: 'absolute', zIndex: 2 }}>
                                <UnfoldMoreIcon fontSize="small" />
                            </Box>
                            <ItemPreviewPage
                                handleClickSelect={() => {
                                    handleClickSelect(item.id);
                                }}
                                page={item}
                                selected={selectedPageId === item.id}
                            />
                        </Box>
                        <Box sx={{ mt: '5px' }}>
                            <Typography
                                fontWeight="bold"
                                variant="caption"
                                sx={{ color: '#ffffff' }}
                            >
                                {t('Page')} {item.page}
                            </Typography>
                        </Box>
                    </ListItemButton>
                </ListItem>
            )}
        </Draggable>
    );
};

SortableItem.propTypes = {
    canUpdate: PropTypes.bool,
    handleClickDelete: PropTypes.func,
    handleClickDuplicate: PropTypes.func,
    handleClickSelect: PropTypes.func,
    selectedPageId: PropTypes.string,
    index: PropTypes.number,
    item: PropTypes.object,
    refDictionary: PropTypes.object,
    scrollDisabled: PropTypes.bool,
};

export default SortableItem;
